import Base from 'app/views/base';

import tmpl from 'templates/carrier_account_list';
import CarrierAccountListItemView from 'app/views/carrier_account_list_item_view';

export default Base.extend({
  compiledTemplate: tmpl,

  events: {},

  initialize() {
    this.listenTo(this.collection, 'sync', this.render);
    this.listenTo(this.collection, 'remove', this.render);
  },

  beforeRender() {
    this.removeSubviews();
    this.collection.each((ca) => {
      this.addSubview(`ca_${ca.id}`, `#ca_${ca.id}`, new CarrierAccountListItemView({
        model: ca,
        collection: this.collection,
      }));
    });
  },

  context() {
    return { carrier_accounts: this.collection.models };
  },
});



// WEBPACK FOOTER //
// ./app/views/carrier_account_list_view.js